<template>
  <div id="ourServices" class="w-full relative text-center mt-32">
    <div class="text-button-brown font-bold text-6xl">{{ t("home.ourServices") }}</div>

    <img src="@/assets/images/shared/starIconGreen.svg" class="m-auto" style="width: 1.76vw" />
    <div id="ourServicesCategories" class="flex justify-center space-x-7 mt-5">
      <div
        v-for="(item, index) in homeStore.ourServicesCategoryList"
        :key="'ourServicesCategoryItem' + index"
        class="hover:shadow-normal p-8"
        @mouseover="homeStore.ourServicesCategoryListOnHover[index] = true"
        @mouseleave="homeStore.ourServicesCategoryListOnHover[index] = false"
        style="width: 20vw"
      >
        <img src="@/assets/images/home/heart.svg" v-show="item.id == 'wellness' && homeStore.ourServicesCategoryListOnHover[index] == false" style="width: 3vw; height: 3.75rem; margin: auto" />
        <img src="@/assets/images/home/heartGreen.svg" v-show="item.id == 'wellness' && homeStore.ourServicesCategoryListOnHover[index] == true" style="width: 3vw; height: 3.75rem; margin: auto" />
        <img src="@/assets/images/home/stethoscope.svg" v-show="item.id == 'treatment' && homeStore.ourServicesCategoryListOnHover[index] == false" style="width: 3vw; height: 3.75rem; margin: auto" />
        <img src="@/assets/images/home/stethoscopeGreen.svg" v-show="item.id == 'treatment' && homeStore.ourServicesCategoryListOnHover[index] == true" style="width: 3vw; height: 3.75rem; margin: auto" />
        <img src="@/assets/images/home/needle.svg" v-show="item.id == 'prevention' && homeStore.ourServicesCategoryListOnHover[index] == false" style="width: 3vw; height: 3.75rem; margin: auto" />
        <img src="@/assets/images/home/needleGreen.svg" v-show="item.id == 'prevention' && homeStore.ourServicesCategoryListOnHover[index] == true" style="width: 3vw; height: 3.75rem; margin: auto" />

        <div class="text-5xl pt-3.5 pb-12" :style="[homeStore.ourServicesCategoryListOnHover[index] ? 'color: var(--button-green-color);font-weight:bold;' : 'color: var(--primary-text);']">
          {{ item.label }}
        </div>
        <div :style="[homeStore.ourServicesCategoryListOnHover[index] ? 'visibility: visible' : 'visibility: hidden']" v-html="item.description" class="text-base font-medium font-jost"></div>
      </div>
    </div>

    <div id="ourServicesCentre" class="mt-5 flex justify-center">
      <div id="ourServicesCentreSelection" class="flex flex-col justify-center items-center text-2xl p-24 w-1/2">
        <div
          v-for="(item, index) in homeStore.ourServicesCentreList"
          :key="'ourServicesCentreItem' + index"
          @click="homeStore.selectedOurServicesCentre = item"
          class="w-full p-5 mb-3 cursor-pointer rounded-2xl"
          :style="[homeStore.selectedOurServicesCentre == item ? 'color: var(--button-brown-color);font-weight:bold;background: #F5F5F5;' : 'color: var(--unselected-color)']"
        >
          <img :src="commonStore.getImgUrl('shared', 'starIconBrownLittle', 'svg')" class="inline" v-show="homeStore.selectedOurServicesCentre == item" style="width: 1.27vw" />
          <span class="pl-6">{{ item.label }}</span>
        </div>
        <!-- <button-util buttonType="button" bgColor="#603813" label="home.findOutMore" @click="routeTo('comingsoon')" /> -->
      </div>

      <div id="ourServicesCentreVideo" class="bg-grey-background p-16" style="width: 37.85vw">
        <img :src="commonStore.getImgUrl('home', 'checkUpCentre', 'svg')" class="m-auto" style="width: inherit" v-show="homeStore.selectedOurServicesCentre.id == 'checkupcentre'" />
        <img :src="commonStore.getImgUrl('home', 'callCentre', 'svg')" class="m-auto" style="width: inherit" v-show="homeStore.selectedOurServicesCentre.id == '24hourcallcentre'" />
        <img :src="commonStore.getImgUrl('home', 'daySurgery', 'svg')" class="m-auto" style="width: inherit" v-show="homeStore.selectedOurServicesCentre.id == 'daysurgery'" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useHomeStore } from "@/stores/home";
import { useCommonStore } from "@/stores/common";

import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();
const router = useRouter();
const homeStore = useHomeStore();
const commonStore = useCommonStore();

onMounted(async () => {
  //assign value
  for (var i = 0; i < homeStore.ourServicesCategoryList.length; i++) {
    homeStore.ourServicesCategoryListOnHover[i] = false;
  }
  if (homeStore.selectedOurServicesCentre.id == null) homeStore.selectedOurServicesCentre = homeStore.ourServicesCentreList[1];
});

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>

